////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { find, isUndefined } from 'lodash'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import { articleStatusPicsConfig } from '../../../constants/AssetsPicturesConfigList'

/////////STYLED/////////
const StatusWrapper = styled.div`
	max-height: auto;
	max-width: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`
const DistributionGroupRepositoryStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => props.colorCode};
	color: ${(props) => props.theme.text.colors.primary};
	line-height: 32px;
	padding: 0px 10px;
`
const DistributionGroupPicto = styled.img`
	max-height: 20px;
	max-width: 20px;
	margin-right: 5px;
`
/////////STYLED/////////

const DistributionGroupRepositoryStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const f = find(articleStatusPicsConfig, { subFlow: props?.row?.itemStatus?.subFlow })

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<StatusWrapper>
			{!isUndefined(f) && <DistributionGroupPicto src={f.picture} />}
			<DistributionGroupRepositoryStatusWrapper>
				{translations[props?.row?.itemStatus?.translationKey]}
			</DistributionGroupRepositoryStatusWrapper>
		</StatusWrapper>
	)
}

DistributionGroupRepositoryStatus.propTypes = {}

DistributionGroupRepositoryStatus.defaultPropTypes = {}

export default DistributionGroupRepositoryStatus
